import { render, staticRenderFns } from "./team-selector.vue?vue&type=template&id=1e0dc899"
import script from "./team-selector.vue?vue&type=script&lang=js"
export * from "./team-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports